import React, { useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // Import hooks from React Router
import axios from "axios";

import CAR from "../../../Images/customer/policy-car.svg";
import TWO from "../../../Images/customer/policy-bike.svg";
import HLT from "../../../Images/customer/policy-health.svg";

const ClaimSubmitt = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const policyData = location.state?.policyData[0]; // Extract policyData from navigation state
    const [btnValue, setBtnValue] = useState("Continue");
    const [loaderText, setLoaderText] = useState("Continue");
    const [claimDescription, setClaimDescription] = useState("");
    const [error, setError] = useState({});

    console.log(policyData, "PRV Data")
    const descriptionRef = useRef();

    const requestSubmit = async () => {
        let isValid = true;
        let validationErrors = {};
        setLoaderText("Wait...");

        if (!claimDescription) {
            isValid = false;
            validationErrors["ClaimDesc"] = "Enter Details";
        } else if (claimDescription.length < 10) {
            isValid = false;
            validationErrors["ClaimDesc"] = "Enter at least 10 characters";
        }

        setError(validationErrors);
        if (!isValid) {
            setLoaderText("Continue");
            return;
        }

        setBtnValue("Wait");
        const requestData = {
            MotorPolicyID: policyData?.motorPolicyID,
            PolicySource: policyData?.policySource,
            PolicyNo: policyData?.policyNo,
            EmailID: policyData?.email,
            MobileNo: policyData?.mobile,
            ClaimFor: policyData?.product,
            ClaimDesc: claimDescription,
            Name: policyData?.customerName,
        };

        try {
            const response = await axios.post(
                "https://crmapi.smcinsurance.com:8081/api/External/RetailCustomerClaimSave",
                requestData,
                {
                    headers: {
                        Token: "d41d8cd98f00b204e9800998ecf8427e",
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response?.data?.statusCode === 201) {
                navigate("/thanks", {
                    state: { Data: { ...requestData, response: response.data } },
                });
            } else {
                alert("Claim request failed to create.");
            }
        } catch (error) {
            console.error("Error submitting claim request:", error);
        } finally {
            setBtnValue("Continue");
            setLoaderText("Continue");
        }
    };

    return (
        <div className="otpclaim">
            <div className="p-2 mt-3 text-center">
                <div className="claiMBackP">
                    <span
                        className="claiMBack"
                        onClick={() => navigate(-1)} // Go back to the previous page
                    >
                        <i className="fas fa-long-arrow-alt-left"></i> Back
                    </span>
                    <h2>
                        File Your <span className="greek">Claim</span>!
                    </h2>
                </div>
                <div className="otp mt-3">
                    <div className="DEtailClaim">
                        {policyData?.motorType === "TwoWheeler" ? (
                            <div className="DEC-otp">
                                <img src={TWO} alt="Two Wheeler" className="bike bikeTEll" />
                                <span className="MotorDat mb-0">{policyData?.vehicleNo}</span>
                            </div>
                        ) : policyData?.motorType === "Car" || policyData?.motorType === "PrivateCar" ? (
                            <div className="DEC-otp">
                                <img src={CAR} alt="Car" className="bike bikeTEll" />
                                <span className="MotorDat mb-0">{policyData?.vehicleNo}</span>
                            </div>
                        ) : (
                            <div className="DEC-otp">
                                <img src={HLT} alt="Health" className="bike bikeTEll" />
                                <span className="MotorDat mb-0">Health Plan Name</span>
                            </div>
                        )}
                        <img src={policyData.companylogo} alt="Company Logo" className="w-25" />
                        <span className="DEC-poli text-start">
                            Policy Number <br /> {policyData?.policyNo}
                        </span>
                    </div>
                    <div className="mt-4 TEEST-TELL">
                        <h4>Tell us what happened?</h4>
                        <p>Please enter whatever details you can provide for us to get started immediately</p>
                        <textarea
                            rows="5"
                            className="text-left textareas"
                            ref={descriptionRef}
                            value={claimDescription}
                            onChange={(e) => setClaimDescription(e.target.value)}
                            placeholder="Enter details here"
                        />
                        <span className="error">{error.ClaimDesc}</span>
                        <div className="mt-2">
                            <button className="newcRT d-block w-100" onClick={requestSubmit}>
                                {loaderText}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClaimSubmitt;
